import { useState, useCallback } from 'react';
import { message } from 'antd';
import { pw9322Api, QueryParams, LeaveRow } from '../../../services/pw9322Api';

export function usePW9322Query() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<LeaveRow[]>([]);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);
  const [totalDay, setTotalDay] = useState(0);

  const runQuery = useCallback(async (params: QueryParams) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await pw9322Api.query(params);
      if (resp.data && resp.data.length > 0) {
        setData(resp.data);
        setTotalDay(resp.total_day ?? 0);
        setNoData(false);
      } else {
        setData([]);
        setTotalDay(0);
        setNoData(true);
        message.info(resp.message || '查無此資料!');
      }
      setQueried(true);
    } catch {
      message.error('查詢失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setData([]);
    setQueried(false);
    setNoData(false);
    setTotalDay(0);
  }, []);

  return { loading, data, queried, noData, totalDay, runQuery, reset };
}
